<script setup lang="ts">
import type { IconName } from "@verbleif/lib/src/components/Icon/icons";
import VIcon from "@verbleif/lib/src/components/Icon/VIcon.vue";
import { computed } from "vue";

const props = defineProps<{
  icon: IconName
  variant?: "default" | "danger" // Add more variants as needed
  text: string
  count?: number
}>();

// Dynamically compute the classes based on the variant
const computedVariantClass = computed(() => {
  switch (props.variant) {
    case "danger":
      return "text-red-500";
    default:
      return ""; // Default styles or no extra classes
  }
});
</script>

<template>
  <div class="flex items-center cursor-pointer text-sm text-gray-800 dark:text-gray-100 hover:bg-gray-100 dark:hover:bg-dark-600 py-1 px-4">
    <div
      class="w-5 flex items-center justify-center"
      :class="computedVariantClass"
    >
      <VIcon :name="icon" />
    </div>
    <div class="mx-1">
      {{ text }}
    </div>
    <div v-if="count" class="rounded-full bg-red-500 text-white text-[0.65rem] min-w-[1rem] h-4 px-1 flex items-center justify-center leading-none">
      {{ count }}
    </div>
  </div>
</template>
